/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
/* eslint-disable import/no-unresolved */
import Divider from '@mui/material/Divider';
import { Grid } from '@mui/system';
import { Fragment } from 'react';
import GET_FOOTER from '../../query/footer';
import { useFetchGraphQL } from '../../hooks';

import { FooterShimmer } from '../Shimmer';

function Footer() {
  const { loading, error, data } = useFetchGraphQL(GET_FOOTER);
  const footerData = data?.footer;

  if (loading) return <FooterShimmer />;
  if (error) return <p>Error! {error.message}</p>;
  if (!footerData) return null;

  return (
    <footer>
      <Grid className="footer-wrapper" maxWidth={'100vw'}>
        <Grid container justifyContent={'space-between'} rowSpacing={{ xs: 4.5, sm: 2, md: 0 }} size={{ xs: 12, sm: 6 }}>
          {footerData?.navigationBox?.map((item) => (
            <Grid size={{ xs: 12, sm: 5, md: 3 }}>
              <div className="footer-box-title">{item?.title}</div>
              <div className="footer-links-items">
                <ul>
                  {item?.links?.map((i) => <li key={i?.id}><a href={i?.url} target={i?.isExternal ? '_blank' : '_self'} rel="noreferrer">{i?.label?.slice(0, 40)}</a></li>)}
                </ul>
              </div>
            </Grid>
          ))}
          <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
            <div className="footer-box-title">{footerData?.contactInfoBox?.title}</div>
            <div className="footer-links-items">
              <ul>
                {footerData?.contactInfoBox?.infoDetailsList?.map((i) => (
                  <div key={i?.id} className="contact-info-items">
                    <img src={`${i?.icon?.url}`} alt={i?.icon?.name} />
                    {i?.label && i?.label.includes('@') ? (
                      <span>
                        <a style={{ textDecoration: 'none', color: 'inherit' }} href={`mailto:${i?.label}`}>{i?.label}</a>
                      </span>
                    ) : (
                      <span>{i?.label}</span>
                    )}
                  </div>
                ))}
              </ul>
            </div>
          </Grid>
          <Grid item size={{ xs: 12, sm: 5, md: 3 }}>
            <div className="footer-box-title">{footerData?.socialLinkBox?.title}</div>
            <div className="footer-social-links-items">
              <ul>
                {footerData?.socialLinkBox?.iconLinkList?.map((i) => (
                  <li key={i?.id}>
                    <a href={i?.url} target="_blank" rel="noreferrer">
                      <img src={`${i?.icon?.url}`} alt={i?.icon?.name} />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="footer-download-links-items">
              <ul>
                {footerData?.downloadLinks?.map((i) => (
                  <li key={i?.id}>
                    <a href={i?.url} target="_blank" rel="noreferrer">
                      <img src={`${i?.linkImage?.url}`} alt={i?.linkImage?.name} />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </Grid>
        </Grid>
        <Divider component="div" sx={{ borderColor: '#F3F3F3', margin: { md: '70px 0px 24px 0px', sm: '24px 0px 24px 0px' }, width: '100%', display: { xs: 'none', sm: 'block' } }} />
        <Grid container className="footer-bottom" rowSpacing={{ xs: 2, sm: 0 }} flexDirection={{ xs: 'column-reverse', sm: 'row' }}>
          <Grid item size={{ xs: 12, sm: 6 }}>
            <div>© {new Date().getFullYear()} {footerData?.footerBottom?.copyRights}</div>
          </Grid>
          <Grid item size={{ xs: 12, sm: 6 }} sx={{ display: 'flex', alignItems: 'center', justifyContent: { xs: 'flex-start', sm: 'flex-end' }, gap: 2 }}>
            {footerData?.footerBottom?.privacyLinks?.map((i, index) => (
              <Fragment key={i.id}>
                <a
                  href={i.label === 'Privacy Policy' ? '/privacy-policy' : '/terms-and-conditions'}
                >
                  {i?.label?.slice(0, 25)}
                </a>
                {index < footerData.footerBottom.privacyLinks.length - 1 && <Divider orientation="vertical" flexItem />}
              </Fragment>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </footer>
  );
}

export default Footer;
